export default "__VITE_ASSET__p$rd598p__"